// extracted by mini-css-extract-plugin
export var localeSelector = "_7l-0";